/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Grid,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import useStyle from './useStyle';
import { InternalPage } from '../../Layouts';
import {
  getProvinceService,
} from '../../services';
import { Toaster, Loading } from '../../components';
import updateProvinces from '../../services/provinces/updateProvinces';

const DistributionPOS = (props) => {
  const {
    type,
  } = props;
  const classes = useStyle();

  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState([]);
  const [provincesData, setProvincesData] = useState([]);
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });

  const updateArray = (event, item) => {
    if (event.target.checked) {
      setChecked(checked.map((p) => {
        const typeFlow = type === 'request-card' ? { ...p, enabled_card_request: true } : { ...p, enabled_mpos_request: true };
        return p.province_id === item.province_id ? typeFlow : p;
      }));
    } else {
      setChecked(checked.map((p) => {
        const typeFlow = type === 'request-card' ? { ...p, enabled_card_request: false } : { ...p, enabled_mpos_request: false };
        return p.province_id === item.province_id ? typeFlow : p;
      }));
    }
  };

  const updateProvincesData = async (data) => {
    setLoading(true);
    const res = await updateProvinces(data)
      .catch(() => setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' }));
    setLoading(false);
    if (res?.status !== 200) return setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' });
    if (res?.status === 200) return setProvincesData(res.data);
    return true;
  };

  const getProvince = async () => {
    setLoading(true);
    const res = await getProvinceService()
      .catch(() => setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' }));
    setLoading(false);
    if (res?.status !== 200) return setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' });
    if (res.data !== undefined) {
      setProvincesData(res.data);
      setChecked(res.data);
    }
    return setProvincesData(res.data);
  };

  const onSelectAll = () => {
    const typeRequest = checked.filter((i) => (type === 'request-card' ? i.enabled_card_request === true : i.enabled_mpos_request === true));
    if (typeRequest.length === checked.length) {
      setChecked(provincesData.map((i) => ({
        country_id: i.country_id,
        province_id: i.province_id,
        province_name: i.province_name,
        province_cod: i.province_cod,
        enabled_card_request: type === 'request-card' ? false : i?.enabled_card_request,
        enabled_mpos_request: type !== 'request-card' ? false : i?.enabled_mpos_request,
      })));
    } else {
      setChecked(provincesData.map((i) => ({
        country_id: i.country_id,
        province_id: i.province_id,
        province_name: i.province_name,
        province_cod: i.province_cod,
        enabled_card_request: type === 'request-card' ? true : i?.enabled_card_request,
        enabled_mpos_request: type !== 'request-card' ? true : i?.enabled_mpos_request,
      })));
    }
  };

  const btnSelectAll = () => {
    const typeRequest = checked.filter((i) => (type === 'request-card' ? i.enabled_card_request === true : i.enabled_mpos_request === true));
    return typeRequest.length !== checked.length ? 'Seleccionar todos' : 'Deseleccionar todos';
  };

  useEffect(() => {
    getProvince();
  }, []);

  return (
    <InternalPage loading={loading} error={alert.type === 'error'}>
      {type === 'request-card' && <Typography className={classes.title}>Selecciona la/s provincia/s hábil/es para solicitar tarjetas</Typography>}
      <Paper className={classes.container}>
        {loading
          ? <Loading />
          : (
            <>
              <Grid>
                <Grid container>
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell size="small" className={classes.text} align="center">Habilitado</TableCell>
                          <TableCell className={classes.text} align="center">Provincia</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className={classes.heightTable}>
                        {provincesData && checked.map((item) => (
                          <TableRow hover key={item.province_id}>
                            {type === 'request-card' ? (
                              <TableCell size="small" className={classes.text} align="center">
                                <Checkbox
                                  checked={item.enabled_card_request}
                                  onChange={(e) => updateArray(e, item)}
                                  size="small"
                                  color="primary"
                                />
                              </TableCell>
                            ) : (
                              <TableCell size="small" className={classes.text} align="center">
                                <Checkbox
                                  checked={item.enabled_mpos_request}
                                  onChange={(e) => updateArray(e, item)}
                                  size="small"
                                  color="primary"
                                />
                              </TableCell>
                            )}
                            <TableCell className={classes.text} align="center">{item.province_name}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                <Grid style={{ flexDirection: 'row', alignContent: 'space-between', padding: 10 }}>
                  <Button style={{ marginRight: 50 }} variant="outlined" color="primary" onClick={() => onSelectAll()}>
                    {checked && btnSelectAll()}
                  </Button>
                  <Button variant="contained" color="primary" onClick={() => updateProvincesData(checked)}>
                    {type === 'request-card' ? 'Guardar' : 'Actualizar'}
                  </Button>
                </Grid>
              </Grid>
              <Toaster
                show={alert.status}
                type={alert.type}
                text={alert.message}
                onClose={() => setAlert({ ...alert, status: false })}
              />
            </>
          )}
      </Paper>
    </InternalPage>
  );
};

DistributionPOS.propTypes = {
  type: PropTypes.string,
};

export default DistributionPOS;
